import store from '@/store';

export default {
   path: '/multicotizador/caucion',
   name: 'caucion',
   children: [
      {
         path: 'datos',
         name: 'caucion/datosCaucion',
         component: () =>
            import(
               /* webpackChunkName: "poliza/consulta" */ '@/modules/caucion/views/DatosCaucionView.vue'
            ),
         beforeEnter: (to, from, next) => {
            if (store.state.poliza.poliza.id_poliza === null) {
               store.commit('main/resetClientData');
               next('/menu');
               return;
            }
            next();
         },
      },
      {
         path: 'formalidad',
         name: 'caucion/formalidad',
         component: () =>
            import('@/modules/caucion/views/FormalidadesCaucionView.vue'),
         beforeEnter: (to, from, next) => {
            if (store.state.poliza.poliza.id_poliza === null) {
               store.commit('main/resetClientData');
               next('/menu');
               return;
            }
            if (store.state.cliente.referente.cuit === null) {
               store.commit('main/resetReferenteData');
               next('/menu');
               return;
            }
            next();
         },
      },
   ],
};
